import { Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { generalService } from '../services/general.service';
import { DataSourceGrid } from '../utils/data-source-grid.component';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { ClienteSAE } from '../models/cliente-sae';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'my-cliente-sae',
  templateUrl: './cliente-sae.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class ClienteSaeComponent implements OnInit {

  public cliente: ClienteSAE;
  public clientes: ClienteSAE[] = [];
  public variable;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'razonSocial', 'rfc', 'telefono', 'municipio', 'estado'];
  public parametroUrl:any;
  public webServ:string;

  constructor(private _generalService: generalService,
            public _activated : ActivatedRoute) {
    this.cliente = new ClienteSAE();
    this._activated.params.forEach((params: Params)=>{
      this.parametroUrl = params['parametro'];
      console.log(this.parametroUrl);
    });
  }

  ngOnInit() {
    this.consultarClientes();
  }

  consultarClientes() {
    const loacs = sessionStorage.getItem('acslo');
    if(this.parametroUrl == ':parametro')
    {
      this.webServ = 'clienteSAE/consultarProveedores';
    }
    else
    {
      this.webServ = 'clienteSAE/consultarClientes';
    }
    this._generalService.metodoCallParams(loacs, this.webServ)
        .subscribe((clientes) => {
          this.clientes = clientes;
          this.dataSource = new DataSourceGrid(this.clientes, this.paginator, this.sort);

          if (this.clientes.length <= 0) {
            this.dataSource = undefined;
          }
      }, (error) => {
        console.log(error);
        this._generalService.toastCall(error);
      }
    );
  }

  confirmarEliminar(cliente) {
    this.cliente.idCliente = cliente.idCliente;
    const eliminarHttp = new EventEmitter();
    eliminarHttp.subscribe((ok) => {
      this._generalService.toastCall(ok.message);
      this.consultarClientes();
    });
    this._generalService.modal(eliminarHttp,
                               'confirm',
                               `¿Desea eliminar el Cliente ${cliente.razonSocial}?`,
                               'clienteSAE/eliminarCliente',
                               this.cliente.idCliente);
  }


searchFilter(searchTerm: string) {
  if(this.clientes.length <= 0) {
    this.dataSource = undefined;
  } else {
    let filtroClientes = this.clientes;
    if(searchTerm != "") {
      filtroClientes = this.clientes.filter((obj: any) => {            
        if (obj.razonSocial.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 || 
            obj.rfc && obj.rfc.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 )
            return true;
        else
            return false;
      });
    }
    this.dataSource = new DataSourceGrid(filtroClientes, this.paginator, this.sort);
  }
}


}



// WEBPACK FOOTER //
// ./src/app/cliente-sae/cliente-sae.component.ts